'use client'

import _ from 'lodash'
import { useEffect, useState } from 'react'
import { redirect } from 'next/navigation'
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google'
import { Button } from '@/components'
import { googleClientId, pages } from '@/settings'
import { authApi } from '@/api'
import { useGlobalStore } from '@/store/provider'
import { Auth } from '@/types/auth'


// https://blog.logrocket.com/guide-adding-google-login-react-app/

export function SignInWithGoogle({ afterSignIn }: Auth.SignInProps) {
  const { user, setUser } = useGlobalStore((state) => state)
  const [isWorking, setIsWorking] = useState(false)
  const [token, setToken] = useState<string | null | any>(null)

  async function signIn() {
    setIsWorking(true)
    try {
      const { data } = await authApi.signInWithGoogle({ token })
      setUser(data, null)
    } catch {
      setIsWorking(false)
    }
  }

  useEffect(() => {
    if (_.isEmpty(user) || !isWorking) return
    setIsWorking(false)
    if (afterSignIn) {
      afterSignIn()
    } else {
      redirect(pages.myProfile.href)
    }
  }, [user])

  useEffect(() => {
    if (token) {
      signIn()
    }
  }, [token])

  const BtnLogin = () => {
    const login = useGoogleLogin({
      onSuccess: codeResponse => setToken(codeResponse.access_token),
    })
    return (
      <Button type='button' variant='outline' className='btn-signin' onClick={() => login()} working={isWorking}>
        <img src='/img/google-logo-128.png' className='w-5 mr-3' />
        Sign in with Google
      </Button>
    )
  }

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <BtnLogin />
    </GoogleOAuthProvider>
  )
}